console.log('[AB Upsell] JS file loaded');
(function () {
  'use strict';

var STORAGE_KEY = 'ab_customer_behavior_v1';
var MAX_ITEMS_TO_SHOW = 10;
var AB_CURRENT_UPSELL_PRODUCTS = [];


var PRIORITY_KEYWORD_RULES = [
  {
    keywords: [
      'baby hamper',
      'baby hampers',
      'baby gift hamper',
      'baby gift hampers',
      'gift hamper',
      'gift hampers',
      'hamper',
      'hampers',
      'baby gift',
      'baby gifts',
      'new baby gift',
      'new parents',
      'new parent',
      'welcome baby',
      'welcome home',
      'baby shower gift',
      'premium gift box',
      'gift box'
    ],
    collection: 'unisex-baby-gifts'
  },
  {
    keywords: [
      'newborn',
      'new born',
      'newborn baby',
      'new born baby',
      'newborn hamper',
      'newborn hampers',
      'newborn baby hamper',
      'new born baby hamper',
      'newborn baby gift',
      'new born baby gift',
      'newborn baby gifts',
      'new born baby gifts',
      'tiny tot',
      'tiny tots',
      'baby socks',
      'rattle',
      'rattles',
      'teether',
      'teethers',
      'muslin wrap',
      'muslin wraps',
      'grow suit',
      'growsuit',
      'onesie',
      'onesies'
    ],
    collection: 'newborn-baby-hampers'
  },
  {
    keywords: [
      'baby boy',
      'baby boy gift',
      'baby boy gifts',
      'baby boy hamper',
      'baby boy hampers',
      'boy hamper',
      'boy hampers',
      'newborn boy',
      'new born baby boy',
      'newborn baby boy',
      'blue',
      'baby blue',
      'boys clothes',
      'toys for boys',
      'baby boy birthday',
      'boy birthday'
    ],
    collection: 'baby-boy-hampers'
  },
  {
    keywords: [
      'baby girl',
      'baby girl gift',
      'baby girl gifts',
      'baby girl hamper',
      'baby girl hampers',
      'girl hamper',
      'girl hampers',
      'newborn girl',
      'new born baby girl',
      'newborn baby girl',
      'pink',
      'floral',
      'girls clothes',
      'toys for girls',
      'baby girl birthday',
      'girl birthday'
    ],
    collection: 'baby-girl-hampers'
  },
  {
    keywords: [
      'baby shower',
      'baby shower hamper',
      'baby shower hampers',
      'baby shower gift',
      'baby shower gifts',
      'mum to be',
      'mum-to-be',
      'mother to be',
      'expecting mum',
      'expecting parents',
      'parents to be',
      'pregnancy gift',
      'pregnancy hamper'
    ],
    collection: 'baby-shower-hampers'
  },
  {
    keywords: [
      'unisex',
      'neutral',
      'gender neutral',
      'neutral baby',
      'neutral baby gift',
      'neutral baby gifts',
      'neutral baby hamper',
      'neutral baby hampers',
      'cream',
      'white',
      'beige',
      'grey',
      'gray'
    ],
    collection: 'unisex-baby-gifts'
  },
  {
    keywords: [
      'mum',
      'mums',
      'mother',
      'mothers',
      'mummy',
      'mama',
      'gifts for mum',
      'gift for mum',
      'mum gift',
      'mum gifts',
      'mum hamper',
      'mum and baby',
      'mum & baby',
      'new mum',
      'new mother',
      'parent gift',
      'parents gift',
      'pamper',
      'pampering',
      'self care',
      'self-care'
    ],
    collection: 'gifts-for-mum'
  },
  {
    keywords: [
      'bath',
      'bathtime',
      'bath time',
      'baby bath',
      'baby bath time',
      'bath hamper',
      'bathe',
      'towel',
      'hooded towel',
      'washer',
      'washers',
      'face washer',
      'face washers',
      'muslin face washer',
      'bath essentials',
      'baby bath essentials'
    ],
    collection: 'baby-bath-time'
  },
  {
    keywords: [
      'feeding',
      'feed',
      'feed time',
      'mealtime',
      'meal time',
      'baby feeding',
      'bottle',
      'baby bottle',
      'bibs',
      'bib',
      'burp cloth',
      'burp cloths',
      'dining',
      'tiny dining',
      'munchkin',
      'plate',
      'bowl',
      'spoon',
      'cup'
    ],
    collection: 'baby-feeding'
  },
  {
    keywords: [
      'breast feeding',
      'breastfeeding',
      'breast pump',
      'pump',
      'mumilk',
      'breast milk',
      'milk collection',
      'milk storage',
      'storage bags',
      'nursing',
      'nursing mum',
      'breastfeeding mum'
    ],
    collection: 'breast-feeding'
  },
  {
    keywords: [
      'bundle',
      'bundles',
      'baby bundle',
      'baby bundles',
      'baby gift bundle',
      'baby gift bundles',
      'baby clothing bundle',
      'baby clothing bundles',
      'baby toy bundle',
      'baby toys bundle',
      'baby essentials bundle',
      'baby essentials bundles',
      'essentials bundle',
      'starter bundle'
    ],
    collection: 'baby-essentials-bundles'
  },
  {
    keywords: [
      'birthday',
      '1st birthday',
      'first birthday',
      'baby birthday',
      'baby boy birthday',
      'baby girl birthday',
      'birthday gift',
      'birthday gifts',
      'birthday hamper',
      'birthday hampers',
      'milestone',
      'one year old'
    ],
    collection: 'baby-girl-birthday-gifts'
  },
  {
    keywords: [
      'clothing',
      'clothes',
      'baby clothing',
      'baby clothes',
      'outfit',
      'outfits',
      'romper',
      'rompers',
      'bodysuit',
      'body suit',
      'body suits',
      'onesie',
      'onesies',
      'grow suit',
      'growsuit',
      'sleep suit',
      'sleepsuit',
      'jumpsuit',
      'baby socks',
      'socks',
      'bib',
      'bibs',
      'hat',
      'beanie',
      'organic cotton'
    ],
    collection: 'baby-essentials-bundles'
  },
  {
    keywords: [
      'blanket',
      'blankets',
      'wrap',
      'wraps',
      'baby blanket',
      'baby blankets',
      'baby wrap',
      'baby wraps',
      'muslin',
      'muslin wrap',
      'muslin wraps',
      'swaddle',
      'swaddles',
      'comforter',
      'security blanket',
      'weegoamigo',
      'little linen',
      'the little linen company',
      'living textiles'
    ],
    collection: 'unisex-baby-gifts'
  },
  {
    keywords: [
      'toy',
      'toys',
      'baby toy',
      'baby toys',
      'play',
      'play time',
      'playtime',
      'rattle',
      'rattles',
      'teether',
      'teethers',
      'plush',
      'plush toy',
      'soft toy',
      'soft toys',
      'cuddly toy',
      'comfort toy',
      'activity toy',
      'newborn baby toys',
      'toys for boys',
      'toys for girls'
    ],
    collection: 'unisex-baby-gifts'
  },
  {
    keywords: [
      'christmas',
      'xmas',
      'holiday',
      'christmas hamper',
      'christmas gift',
      'christmas gifts',
      'warm hugs',
      'festive',
      'baby christmas'
    ],
    collection: 'unisex-baby-gifts'
  },
  {
    keywords: [
      'melbourne',
      'same day',
      'same-day',
      'melbourne metro',
      'local delivery',
      'fast local delivery'
    ],
    collection: 'melbourne'
  },
  {
    keywords: [
      'sydney',
      'adelaide',
      'australia wide',
      'australia-wide',
      'delivery',
      'fast delivery'
    ],
    collection: 'unisex-baby-gifts'
  },
  {
    keywords: [
      'pure baby',
      'purebaby',
      'little bamboo',
      'living textiles',
      'marmalade lion',
      'mumilk',
      'munchkin',
      'weegoamigo',
      'the little linen company',
      'tiny dining',
      'emotion kids'
    ],
    collection: 'unisex-baby-gifts'
  },
  {
    keywords: [
      'sale',
      'promotion',
      'promotions',
      'special',
      'specials',
      'discount',
      'clearance',
      'under 100',
      '$100',
      '$150',
      '$200'
    ],
    collection: 'unisex-baby-gifts'
  }
];

var FALLBACK_COLLECTION = 'unisex-baby-gifts';

function safeJsonParse(value, fallback) {
  if (!value) {
    return fallback;
  }

  try {
    var parsed = JSON.parse(value);
    return parsed || fallback;
  } catch (e) {
    return fallback;
  }
}

/*------------------------*/

document.addEventListener('cart:updated', function () {
  setTimeout(loadUpsells, 300);
});

document.addEventListener('hdt:cart:refresh', function () {
  setTimeout(loadUpsells, 300);
});


document.addEventListener('change', function(e){

  if(
    e.target.matches('input[name="updates[]"]') ||
    e.target.matches('.quantity__input') ||
    e.target.closest('cart-drawer')
  ){
    setTimeout(function(){
      loadUpsells();
    },500);
  }

});

function watchCartDrawerChanges() {
  var drawer = document.getElementById('CartDrawer');

  if (!drawer || !window.MutationObserver) return;

  var observer = new MutationObserver(function(mutations) {

    var shouldReload = mutations.some(function(mutation){
      return mutation.type === 'childList';
    });

    if (shouldReload) {
      clearTimeout(window.abUpsellReloadTimer);

      window.abUpsellReloadTimer = setTimeout(function(){
        loadUpsells();
      },300);
    }
  });

  observer.observe(drawer,{
    childList:true,
    subtree:true
  });
}
/*------------------------*/

function fetchCollectionProductsSafe(collectionHandle, limit) {
  limit = limit || 8;

  function fetchHandle(handle) {
    return fetch('/collections/' + handle + '/products.json?limit=' + limit, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Collection fetch failed: ' + handle);
        return res.json();
      })
      .then(function (data) {
        return {
          handle: handle,
          products: data && data.products ? data.products : []
        };
      });
  }

  return fetchHandle(collectionHandle)
    .then(function (result) {
      if (result.products.length > 0) return result;

      console.warn('[AB Upsell] Empty collection:', collectionHandle, 'Fallback:', FALLBACK_COLLECTION);
      return fetchHandle(FALLBACK_COLLECTION);
    })
    .catch(function (error) {
      console.warn('[AB Upsell] Collection error:', error);
      return fetchHandle(FALLBACK_COLLECTION);
    });
}

function getBehavior() {
  var data = safeJsonParse(localStorage.getItem(STORAGE_KEY), {}) || {};

  return {
    productViews: Array.isArray(data.productViews)
      ? data.productViews
      : Array.isArray(data.products)
        ? data.products
        : [],

    collectionViews: Array.isArray(data.collectionViews)
      ? data.collectionViews
      : Array.isArray(data.collections)
        ? data.collections
        : [],

    searches: Array.isArray(data.searches) ? data.searches : [],

    addedToCart: Array.isArray(data.addedToCart) ? data.addedToCart : [],

    upsellClicks: Array.isArray(data.upsellClicks) ? data.upsellClicks : [],

    lastUpdated: data.lastUpdated || null
  };
}

  function saveBehavior(data) {
    data.lastUpdated = new Date().toISOString();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

function pushUnique(list, item, keyName, max) {
  if (!Array.isArray(list)) {
    list = [];
  }

  if (!item || !item[keyName]) {
    return list;
  }

  var filtered = list.filter(function (oldItem) {
    return oldItem && oldItem[keyName] !== item[keyName];
  });

  filtered.unshift(item);

  return filtered.slice(0, max || 20);
}

  function trackCurrentPage() {
    var ctx = window.AB_UPSELL_PAGE_CONTEXT || {};
    var behavior = getBehavior();

    if (ctx.pageType === 'product' && ctx.product && ctx.product.handle) {
      behavior.productViews = pushUnique(
        behavior.productViews,
        {
          id: ctx.product.id,
          handle: ctx.product.handle,
          title: ctx.product.title,
          url: ctx.product.url,
          collections: ctx.product.collections || [],
          time: Date.now()
        },
        'handle',
        20
      );
    }

    if (ctx.pageType === 'collection' && ctx.collection && ctx.collection.handle) {
      behavior.collectionViews = pushUnique(
        behavior.collectionViews,
        {
          handle: ctx.collection.handle,
          title: ctx.collection.title,
          url: ctx.collection.url,
          time: Date.now()
        },
        'handle',
        20
      );
    }

    if (ctx.pageType === 'search' && ctx.searchTerm) {
      behavior.searches = pushUnique(
        behavior.searches,
        {
          term: String(ctx.searchTerm).toLowerCase(),
          time: Date.now()
        },
        'term',
        20
      );
    }

    saveBehavior(behavior);
  }

  function behaviorText(behavior) {
    var parts = [];

    behavior.collectionViews.forEach(function (item) {
      parts.push(item.handle || '');
      parts.push(item.title || '');
    });

    behavior.productViews.forEach(function (item) {
      parts.push(item.handle || '');
      parts.push(item.title || '');
      if (Array.isArray(item.collections)) {
        parts = parts.concat(item.collections);
      }
    });

    behavior.searches.forEach(function (item) {
      parts.push(item.term || '');
    });

    return parts.join(' ').toLowerCase();
  }

  function normalizeText(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function getCollectionIndex() {
  var rawCollections = Array.isArray(window.AB_COLLECTION_INDEX)
    ? window.AB_COLLECTION_INDEX
    : [];

  var ignoredWords = [
    'and',
    'the',
    'for',
    'with',
    'from',
    'gift',
    'gifts',
    'hamper',
    'hampers',
    'basket',
    'baskets',
    'collection',
    'collections',
    'product',
    'products',
    'shop',
    'all',
    'new',
    'best',
    'selling',
    'sale'
  ];

  return rawCollections
    .filter(function (collection) {
      return collection && collection.handle;
    })
    .map(function (collection) {
      var baseText = normalizeText(
        (collection.handle || '') + ' ' + (collection.title || '')
      );

      var keywords = baseText
        .split(' ')
        .filter(function (word) {
          return word.length > 2 && ignoredWords.indexOf(word) === -1;
        });

      keywords = keywords.filter(function (word, index) {
        return keywords.indexOf(word) === index;
      });

      return {
        handle: collection.handle,
        title: collection.title || collection.handle,
        url: collection.url || '/collections/' + collection.handle,
        keywords: keywords
      };
    });
}

function matchPriorityCollectionFromText(text) {
  text = normalizeText(text);

  for (var i = 0; i < PRIORITY_KEYWORD_RULES.length; i++) {
    var rule = PRIORITY_KEYWORD_RULES[i];

    for (var j = 0; j < rule.keywords.length; j++) {
      var keyword = normalizeText(rule.keywords[j]);

      if (keyword && text.indexOf(keyword) !== -1) {
        return rule.collection;
      }
    }
  }

  return null;
}

function matchDynamicCollectionFromText(text) {
  text = normalizeText(text);

  if (!text) return null;

  var collections = getCollectionIndex();

  if (!collections.length) return null;

  var bestMatch = null;
  var bestScore = 0;

  collections.forEach(function (collection) {
    var score = 0;
    var handleText = normalizeText(collection.handle);
    var titleText = normalizeText(collection.title);

    if (handleText && text.indexOf(handleText) !== -1) {
      score += 10;
    }

    if (titleText && text.indexOf(titleText) !== -1) {
      score += 10;
    }

    collection.keywords.forEach(function (keyword) {
      if (keyword && text.indexOf(keyword) !== -1) {
        score += 2;
      }
    });

    /*
      If text word exactly equals collection keyword, stronger match.
    */
    var textWords = text.split(' ');

    collection.keywords.forEach(function (keyword) {
      if (textWords.indexOf(keyword) !== -1) {
        score += 3;
      }
    });

    if (score > bestScore) {
      bestScore = score;
      bestMatch = collection.handle;
    }
  });

  return bestScore > 0 ? bestMatch : null;
}

function matchCollectionFromText(text) {
  var priorityMatch = matchPriorityCollectionFromText(text);
  if (priorityMatch) return priorityMatch;

  return matchDynamicCollectionFromText(text);
}



 function chooseUpsellCollection(cart) {
  var behavior = getBehavior();
  var ctx = window.AB_UPSELL_PAGE_CONTEXT || {};

  /*
    1. Last added item behavior.
  */
  if (behavior.addedToCart && behavior.addedToCart.length) {
    var lastAdded = behavior.addedToCart[0];

    var lastAddedText = [
      lastAdded.handle || '',
      lastAdded.title || '',
      lastAdded.page || '',
      lastAdded.url || ''
    ].join(' ');

    var lastAddedMatch = matchCollectionFromText(lastAddedText);
    if (lastAddedMatch) return lastAddedMatch;
  }

  /*
    2. Current cart items.
  */
  if (cart && Array.isArray(cart.items) && cart.items.length) {
    var cartText = cart.items.map(function (item) {
      return [
        item.title || '',
        item.product_title || '',
        item.url || '',
        item.handle || '',
        item.vendor || '',
        item.product_type || ''
      ].join(' ');
    }).join(' ');

    var cartMatch = matchCollectionFromText(cartText);
    if (cartMatch) return cartMatch;
  }

  /*
    3. Current page context.
  */
  var currentPageText = '';

  if (ctx.collection) {
    currentPageText += ' ' + (ctx.collection.handle || '');
    currentPageText += ' ' + (ctx.collection.title || '');
  }

  if (ctx.product) {
    currentPageText += ' ' + (ctx.product.handle || '');
    currentPageText += ' ' + (ctx.product.title || '');

    if (Array.isArray(ctx.product.collections)) {
      currentPageText += ' ' + ctx.product.collections.join(' ');
    }
  }

  if (ctx.searchTerm) {
    currentPageText += ' ' + ctx.searchTerm;
  }

  var pageMatch = matchCollectionFromText(currentPageText);
  if (pageMatch) return pageMatch;

  /*
    4. Browsing behavior.
  */
  var behaviorMatch = matchCollectionFromText(behaviorText(behavior));
  if (behaviorMatch) return behaviorMatch;

  /*
    5. Fallback.
  */
  return FALLBACK_COLLECTION;
}

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD'
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function productImage(product) {
    if (product.featured_image) return product.featured_image;

    if (product.images && product.images.length) {
      if (typeof product.images[0] === 'string') return product.images[0];
      if (product.images[0].src) return product.images[0].src;
    }

    return '';
  }

  function firstAvailableVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;

    var available = product.variants.find(function (variant) {
      return variant.available !== false;
    });

    return available || product.variants[0];
  }

  function normalizePrice(product, variant) {
    if (variant && variant.price) {
      var price = variant.price;

      if (typeof price === 'string' && price.indexOf('.') !== -1) {
        return Math.round(parseFloat(price) * 100);
      }

      return Number(price);
    }

    if (product.price) {
      return Number(product.price);
    }

    return 0;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json();
    });
  }

  function fetchCollectionProducts(handle) {
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=30', {
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('Collection not found: ' + handle);
      }

      return res.json();
    }).then(function (data) {
      return data.products || [];
    });
  }

  function filterProducts(products, cart) {
    var cartProductIds = (cart.items || []).map(function (item) {
      return Number(item.product_id);
    });

    return products.filter(function (product) {
      var variant = firstAvailableVariant(product);

      if (!variant) return false;
      if (cartProductIds.indexOf(Number(product.id)) !== -1) return false;

      return true;
    }).slice(0, MAX_ITEMS_TO_SHOW);
  }

function renderUpsells(products) {
  var wrapper = document.getElementById('ABBehaviorUpsell');
  if (!wrapper) return;

  var itemsWrap = wrapper.querySelector('[data-ab-upsell-items]');
  if (!itemsWrap) return;

  if (!products.length) {
    wrapper.hidden = true;
    itemsWrap.innerHTML = '';
    return;
  }

  itemsWrap.innerHTML = [
    '<div class="ab-upsell-carousel" data-ab-carousel>',
      '<button class="ab-upsell-nav ab-upsell-prev" type="button" data-ab-prev aria-label="Previous product">&#8249;</button>',
      '<div class="ab-upsell-viewport">',
        '<div class="ab-upsell-track" data-ab-track>',
          products.map(function (product) {
            var variant = firstAvailableVariant(product);
            var image = productImage(product);
            var price = normalizePrice(product, variant);
            var title = escapeHtml(product.title || '');

            return [
              '<div class="ab-upsell-slide">',
                '<div class="ab-upsell-item" data-ab-upsell-product>',

                  '<button class="ab-upsell-image-link" type="button" data-variant-id="' + variant.id + '" aria-label="Add ' + title + ' to cart">',
                    image ? '<img class="ab-upsell-image" src="' + image + '" alt="' + title + '" loading="lazy">' : '',
                  '</button>',

                  '<div class="ab-upsell-info">',
                    '<button class="ab-upsell-title" type="button" data-variant-id="' + variant.id + '" aria-label="Add ' + title + ' to cart">',
                      title,
                    '</button>',
                    '<div class="ab-upsell-price">' + formatMoney(price) + '</div>',
                  '</div>',

                  '<button class="ab-upsell-add" type="button" data-variant-id="' + variant.id + '" aria-label="Add ' + title + ' to cart">Add</button>',

                '</div>',
              '</div>'
            ].join('');
          }).join(''),
        '</div>',
      '</div>',
      '<button class="ab-upsell-nav ab-upsell-next" type="button" data-ab-next aria-label="Next product">&#8250;</button>',
      '<div class="ab-upsell-dots">',
        products.map(function (_, index) {
          return '<button class="ab-upsell-dot' + (index === 0 ? ' is-active' : '') + '" type="button" data-ab-dot data-index="' + index + '" aria-label="Go to slide ' + (index + 1) + '"></button>';
        }).join(''),
      '</div>',
    '</div>'
  ].join('');

  wrapper.hidden = false;
  initUpsellCarousel(wrapper);
}



function initUpsellCarousel(wrapper) {
  var carousel = wrapper.querySelector('[data-ab-carousel]');
  if (!carousel) return;

  var track = carousel.querySelector('[data-ab-track]');
  var slides = carousel.querySelectorAll('.ab-upsell-slide');
  var prevBtn = carousel.querySelector('[data-ab-prev]');
  var nextBtn = carousel.querySelector('[data-ab-next]');
  var dots = carousel.querySelectorAll('[data-ab-dot]');

  if (!track || !slides.length) return;

  var currentIndex = 0;
  var total = slides.length;

  function updateCarousel() {
    track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';

    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex === total - 1;

    dots.forEach(function (dot, index) {
      dot.classList.toggle('is-active', index === currentIndex);
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      if (currentIndex < total - 1) {
        currentIndex++;
        updateCarousel();
      }
    });
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      currentIndex = Number(dot.getAttribute('data-index')) || 0;
      updateCarousel();
    });
  });

  updateCarousel();
}



function buildSectionUrl(sectionId) {
  var url = window.location.pathname + window.location.search;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
}

function syncCartCount(cart) {
  var selectors = [
    '.hdt-cart-count',
    '[data-cart-count]',
    '.cart-count',
    '.site-header__cart-count'
  ];

  selectors.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.textContent = cart.item_count;
    });
  });
}

function refreshCartDrawerUI() {
  return Promise.all([
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
      return res.json();
    }),
    fetch(buildSectionUrl('cart-drawer'), { credentials: 'same-origin' }).then(function (res) {
      return res.text();
    })
  ])
    .then(function (results) {
      var cart = results[0];
      var html = results[1];

      syncCartCount(cart);

      var temp = document.createElement('div');
      temp.innerHTML = html;

      var currentDrawer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
      var newDrawer = temp.querySelector('#CartDrawer') || temp.querySelector('cart-drawer');

      if (currentDrawer && newDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

      setTimeout(function () {
        loadUpsells();
      }, 150);
    })
    .catch(function (error) {
      console.warn('[AB Upsell] Drawer refresh failed:', error);
      loadUpsells();
    });
}

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

function loadUpsells() {
  fetchCart()
    .then(function (cart) {
      var collectionHandle = chooseUpsellCollection(cart);

      return fetchCollectionProducts(collectionHandle)
        .then(function (products) {
          var filteredProducts = filterProducts(products, cart);
          renderUpsells(filteredProducts);
        });
    })
    .catch(function (error) {
      console.warn('[AB Upsell] Failed:', error);
    });
}
function addVariantToCart(variantId, button) {
  if (!variantId || !button) return;

  button.disabled = true;

  var oldText = button.textContent;
  var isTextButton = button.classList.contains('ab-upsell-add');

  if (isTextButton) {
    button.textContent = 'Adding...';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: 1
    })
  })
    .then(function (res) {
      if (!res.ok) {
        throw new Error('Add to cart failed');
      }

      return res.json();
    })
    .then(function () {
      if (isTextButton) {
        button.textContent = 'Added';
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('hdt:cart:refresh'));


      return refreshCartDrawerUI();
    })
    .then(function () {
      setTimeout(function () {
        loadUpsells();
      }, 200);
    })
    .catch(function (error) {
      console.warn('[AB Upsell] Add failed:', error);
      button.disabled = false;

      if (isTextButton) {
        button.textContent = oldText;
      }
    });
}


  function bindEvents() {
  document.addEventListener('click', function (event) {
    var addTarget = event.target.closest(
      '.ab-upsell-add, .ab-upsell-title, .ab-upsell-image-link'
    );

    if (!addTarget) return;

    event.preventDefault();

    var variantId = addTarget.getAttribute('data-variant-id');

    if (!variantId) return;

    addVariantToCart(variantId, addTarget);
  });

  document.addEventListener('click', function (event) {
    var cartTrigger = event.target.closest(
      '[aria-controls="CartDrawer"], [href="/cart"], .hdt-site-nav__cart, .hdt-cart-count, cart-drawer-opener'
    );

    if (cartTrigger) {
      setTimeout(loadUpsells, 300);
    }
  });

  var drawer = document.getElementById('CartDrawer');

  if (drawer && 'MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      if (drawer.open || drawer.hasAttribute('open')) {
        loadUpsells();
      }
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['open', 'class']
    });
  }
}

function exposeDebug() {
  window.ABUpsellDebug = {
    behavior: getBehavior,

    clear: function () {
      localStorage.removeItem(STORAGE_KEY);
      console.log('AB upsell behavior cleared');
    },

    collection: function () {
      return chooseUpsellCollection();
    },

    collectionWithCart: function () {
      return fetchCart().then(function (cart) {
        return chooseUpsellCollection(cart);
      });
    },

    reload: loadUpsells,

    collections: function () {
      return getCollectionIndex();
    },

    keywords: function () {
      return getCollectionIndex().map(function (collection) {
        return {
          handle: collection.handle,
          title: collection.title,
          keywords: collection.keywords
        };
      });
    },

    reason: function () {
      return fetchCart().then(function (cart) {
        return {
          selectedCollection: chooseUpsellCollection(cart),
          cart: cart.items.map(function (item) {
            return {
              title: item.product_title || item.title,
              url: item.url,
              product_type: item.product_type,
              vendor: item.vendor
            };
          }),
          behavior: getBehavior(),
          currentPage: window.AB_UPSELL_PAGE_CONTEXT || {},
          loadedCollections: getCollectionIndex()
        };
      });
    }
  };
}

function init() {
  exposeDebug();
  trackCurrentPage();
  bindEvents();

  setTimeout(loadUpsells, 800);
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
